import { FC, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'Components/UI';
import Button from 'Components/UI/Button';
import { Popover } from 'antd';
import { Container } from './styles';
import premiumImg from "Static/images/logo-crow-free.png";

interface IPremiumDropdown {
  children: ReactNode;
  role: number;
  onRedirect: (role: number) => void;
}

const PremiumDropdown: FC<IPremiumDropdown> = ({
  children,
  role,
  onRedirect,
}) => {
  const { t } = useTranslation('config');
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const content = (
    <Container>
      <img
        className="imgPremium"
        src={premiumImg}
        alt={t('premiumDropdown.imgAlt')}
      />

      <div className="right">
        <span className="textTitle">
          {role === 1
            ? t('premiumDropdown.upgradePersonal')
            : t('premiumDropdown.upgradeCompany')
          }
        </span>
        <span className="textDescription">
          {t('premiumDropdown.description')}
        </span>
        <Button
          className="btnPremium"
          ispremium="true"
          onClick={() => onRedirect(role)}
        >
          <Icon
            icon="crown"
            customSize={12}
            className="iconCrow"
          />
          {role === 1
            ? t('premiumDropdown.acquireProPersonal')
            : t('premiumDropdown.acquireProCompany')
          }
        </Button>
      </div>

      <Icon
        icon="cancelar"
        className="iconCancel"
        customSize={8}
        onClick={hide}
      />
    </Container>
  );

  return (
    <Popover
      trigger="click"
      placement="bottom"
      open={open}
      content={content}
      onOpenChange={handleOpenChange}
    >
      {children}
    </Popover>
  )
};

export default PremiumDropdown;
